import http from "./httpService";
import { getConfig } from "../config/config.js";
import JSZip from "jszip";
const config = getConfig();

export async function getFiles(id, serviceFolder, subfolder) {
  try {
    const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder + "/";
    const response = await http.post(serviceEndpoint + "/getFiles/" + id, {
      subfolder: subfolder,
    });
    return response.data.archivos;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR"))
      return error.message.toUpperCase();
    else return null;
  }
}

export async function renameFile(
  id,
  serviceFolder,
  subfolder,
  original,
  newName
) {
  try {
    const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder + "/";
    const response = await http.post(serviceEndpoint + "/renameFile/" + id, {
      original: original,
      newName: newName,
      subfolder: subfolder,
    });
    return response.data.archivos;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR"))
      return error.message.toUpperCase();
    else return null;
  }
}

export async function uploadImages(id, serviceFolder, subfolder, data) {
  const newData = new FormData();
  const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder + "/";
  if (subfolder === "") subfolder = "__null";

  data.forEach((file, index) => {
    newData.append("file", file);
  });

  try {
    const response = await http.post(
      serviceEndpoint +
        "uploadImages/" +
        id +
        "/" +
        subfolder.replace(/\//g, "º"),
      newData
    );
    return response.data.archivos;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR"))
      return error.message.toUpperCase();
    else return null;
  }
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export async function updateImages(
  id,
  serviceFolder,
  subfolder,
  imageFile,
  imageData
) {
  const newData = new FormData();
  const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder + "/";
  if (subfolder === "") subfolder = "__null";
  newData.append("file", dataURLtoFile(imageData, imageFile));

  // data.forEach((file, index) => {
  //   newData.append("file", file);
  // });
  try {
    const response = await http.put(
      serviceEndpoint +
        "/updateImages/" +
        id +
        "/" +
        subfolder.replace(/\//g, "º") +
        "/" +
        imageFile,
      newData
    );
    return response.data.archivos;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR"))
      return error.message.toUpperCase();
    else return null;
  }
}

// const uploaderConfig = {
//   onUploadProgress: function (progressEvent) {
//     var percentCompleted = Math.round(
//       (progressEvent.loaded * 100) / progressEvent.total
//     );
//     console.log(percentCompleted);
//   },
// };

const generateUniqueFilename = (originalFilename) => {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 8); // Generates a short random string
  const fileExtension = originalFilename.split(".").pop();
  return `${timestamp}-${randomString}.${fileExtension}`;
};

async function createAndZipFiles(files) {
  const zip = new JSZip();
  for (const file of files) {
    zip.file(file.path, file); // Add each file to the zip
  }
  const zippedBlob = await zip.generateAsync({ type: "blob" });
  return zippedBlob;
}

export async function uploadFiles(
  id,
  serviceFolder,
  currentfolder,
  subfolder,
  data,
  onProgress
) {
  const newData = new FormData();
  const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder;
  if (currentfolder === "") currentfolder = "__home";
  if (subfolder === "") subfolder = "__null";

  let hasFolder = false;
  data.forEach((file) => {
    if (file.path.indexOf("/") === 0) hasFolder = true;
  });

  if (hasFolder) {
    subfolder = "ZIP";
    let zipFile = await createAndZipFiles(data);
    newData.append("file", zipFile, generateUniqueFilename("archive.zip"));
  } else {
    data.forEach((file, index) => {
      newData.append("file", file);
    });
  }
  // const newData = new FormData();
  // const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder;
  // if (currentfolder === "") currentfolder = "__home";
  // if (subfolder === "") subfolder = "__null";
  // data.forEach((file, index) => {
  //   newData.append("file", file);
  // });

  try {
    const response = await http.post(
      serviceEndpoint +
        "/uploadFiles/" +
        id +
        "/" +
        currentfolder.replace(/\//g, "º") +
        "/" +
        subfolder.replace(/\//g, "º"),
      newData,
      onProgress
    );
    return response.data.archivos;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR"))
      return error.message.toUpperCase();
    else return null;
  }
}

export async function deleteFile(id, serviceFolder, subfolder, file) {
  const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder + "/";
  if (subfolder === "") subfolder = "__null";
  return await http.post(
    serviceEndpoint + "/deleteFile/" + id + "/" + subfolder.replace(/\//g, "º"),
    {
      archivo: file,
    }
  );
}

export async function deleteFolder(id, serviceFolder, currentFolder, folder) {
  const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder + "/";
  // if (subfolder === "") subfolder = "__null";
  const subfolder = currentFolder + folder;
  return await http.post(
    serviceEndpoint +
      "/deleteFolder/" +
      id +
      "/" +
      subfolder.replace(/\//g, "º")
  );
}

export async function createFolder(id, serviceFolder, subfolder) {
  try {
    const serviceEndpoint = config.apiEndpoint + "/" + serviceFolder;
    if (subfolder === "") subfolder = "__null";
    const response = await http.post(serviceEndpoint + "/createFolder/" + id, {
      subfolder: subfolder,
    });

    return response.data.archivos;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR"))
      return error.message.toUpperCase();
    else return null;
  }
}
